export enum Type {
  SET_CLOCK = "SET_CLOCK",
}

export interface ISetClock {
  type: Type.SET_CLOCK;
  date: Date;
}

export const setClock = (date: Date): ISetClock => {
  return { type: Type.SET_CLOCK, date };
};
